import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as StoryActions from "../../data/stories/StoryActions";

import CreateStoryDialog from './CreateStoryDialog';

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
    projects: Object.values(state.projects)
});

const mapDispatchToProps = {
    createStory: StoryActions.createStory,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CreateStoryDialog)
);
